import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { listarNivelesAutorizacion } from "../services/niveles-service";

export const nivelesAutorizacionQueryOptions = queryOptions({
  queryKey: qk.adminFlujosAutorizacion,
  queryFn: listarNivelesAutorizacion,
});

export const useNivelesAutorizacion = () =>
  useSuspenseQuery(nivelesAutorizacionQueryOptions);
